<template>
  <div class="price-editor">
    <TopNav />
    <div v-if="loading" class="loading-overlay">
      <div class="spinner"></div>
    </div>
    <div class="column-left">
      <SideNav />
    </div>
    <div class="column-right">
      <div v-if="admin_datos.superadmin" class="main-container">
        <h2 class="page-title">Editor de Guía de Precios</h2>

        <div v-if="editingPage === null" class="page-list">
          <button class="btn btn-add-page" @click="createPage">Nueva Guía</button>
          <ul>
            <li v-for="page in pages" :key="page.slug" class="page-item">
              <span>{{ page.slug }}</span>
              <button class="btn btn-edit" @click="editPage(page)">Editar</button>
              <button class="btn btn-danger" @click="deletePage(page)">Eliminar</button>
            </li>
          </ul>
        </div>

        <div v-else class="page-editor">
          <h3>{{ editingPage.slug || 'nueva-guia' }}</h3>
          <div class="form-group">
            <label>Nombre SEO</label>
            <input v-model="editingPage.slug" class="form-control" />
          </div>
          <div class="form-group">
            <label>Título</label>
            <input v-model="editingPage.titulo" class="form-control" />
          </div>
          <div class="form-group">
            <label>Descripción</label>
            <textarea v-model="editingPage.descripcion" rows="2" class="form-control"></textarea>
          </div>
          <div class="form-group">
            <label>Imagen de Encabezado</label>
            <input v-model="editingPage.imgheader" class="form-control" />
          </div>

          <div class="sections-editor">
            <h4>Secciones</h4>
            <div
              v-for="(section, idx) in editingPage.sections"
              :key="idx"
              class="section-item"
            >
              <select
                v-model="section.type"
                class="form-control type-select"
                @change="onTypeChange(section)"
              >
                <option disabled value="">Tipo...</option>
                <option value="header_image">Imagen de Encabezado</option>
                <option value="title">Título</option>
                <option value="subtitle">Subtítulo</option>
                <option value="paragraph">Párrafo</option>
                <option value="image">Imagen</option>
                <option value="price_range">Rango de Precios</option>
                <option value="table">Tabla</option>
                <option value="faq">FAQ</option>
                <option value="cta">CTA</option>
              </select>
              <div class="editor-block">
                <div v-if="section.type === 'header_image'">
                  <input v-model="section.src" placeholder="URL de la imagen" class="form-control" />
                  <input v-model.number="section.height" type="number" placeholder="Alto" class="form-control" />
                  <label><input type="checkbox" v-model="section.rounded" /> Bordes redondeados</label>
                </div>
                <div v-else-if="section.type === 'title'">
                  <input v-model="section.text" placeholder="Título" class="form-control" />
                </div>
                <div v-else-if="section.type === 'subtitle'">
                  <input v-model="section.text" placeholder="Subtítulo" class="form-control" />
                </div>
                <div v-else-if="section.type === 'paragraph'">
                  <textarea v-model="section.text" rows="4" class="form-control" placeholder="Párrafo"></textarea>
                </div>
                <div v-else-if="section.type === 'image'">
                  <input v-model="section.src" placeholder="URL" class="form-control" />
                  <input v-model="section.alt" placeholder="Alt" class="form-control" />
                  <input v-model="section.caption" placeholder="Leyenda" class="form-control" />
                  <label><input type="checkbox" v-model="section.rounded" /> Bordes redondeados</label>
                </div>
                <div v-else-if="section.type === 'price_range'">
                  <input v-model="section.currency" placeholder="Moneda" class="form-control" />
                  <input v-model.number="section.min" type="number" placeholder="Mín" class="form-control" />
                  <input v-model.number="section.max" type="number" placeholder="Máx" class="form-control" />
                </div>
                <div v-else-if="section.type === 'table'">
                  <div class="table-editor-container">
                  <table class="table-editor">
                    <tr v-for="(row, r) in section.rows" :key="r">
                      <td v-for="(cell, c) in row" :key="c" class="cell-wrapper">
                        <input v-model="section.rows[r][c]" class="form-control" />
                        <button v-if="r === 0" class="btn-remove-col" @click="removeColumn(section, c)">-</button>
                      </td>
                      <td>
                        <button v-if="r > 0" @click="removeRow(section, r)">x</button>
                      </td>
                    </tr>
                  </table>
                  </div>
                  <div class="table-buttons">
                    <button @click="addRow(section)">Añadir fila</button>
                    <button @click="addColumn(section)">Añadir columna</button>
                  </div>
                </div>
                <div v-else-if="section.type === 'faq'">
                  <div v-for="(item, i) in section.items" :key="i" class="faq-item-edit">
                    <input v-model="item.q" placeholder="Pregunta" class="form-control" />
                    <textarea v-model="item.a" rows="2" placeholder="Respuesta" class="form-control"></textarea>
                    <button @click="removeFaqItem(section, i)">Eliminar</button>
                  </div>
                  <button @click="addFaqItem(section)">Añadir pregunta</button>
                </div>
                <div v-else-if="section.type === 'cta'">
                  <input v-model="section.label" placeholder="Texto del botón" class="form-control" />
                </div>
              </div>
              <div class="section-actions">
                <button @click="moveSectionUp(idx)" :disabled="idx === 0">↑</button>
                <button
                  @click="moveSectionDown(idx)"
                  :disabled="idx === editingPage.sections.length - 1"
                >
                  ↓
                </button>
                <button @click="removeSection(idx)">Eliminar</button>
              </div>
            </div>
            <button class="btn btn-add" @click="addSection">Agregar Sección</button>
          </div>

          <div class="preview-box">
            <button class="btn btn-secondary" @click="showPreview = !showPreview">
              {{ showPreview ? 'Ocultar' : 'Mostrar' }} Vista Previa
            </button>
            <div v-if="showPreview" class="preview article-container">
              <section
                v-for="(block, i) in editingPage.sections"
                :key="i"
                :class="`content-section section-${block.type}`"
              >
                <div
                  v-if="block.type === 'header_image'"
                  class="header-image"
                  :class="{ rounded: block.rounded }"
                  :style="{ backgroundImage: `url(${block.src})`, height: (block.height || 220) + 'px' }"
                ></div>
                <h1 v-else-if="block.type === 'title'" class="page-title">{{ block.text }}</h1>
                <h2 v-else-if="block.type === 'subtitle'" class="page-subtitle">{{ block.text }}</h2>
                <p v-else-if="block.type === 'paragraph'" v-html="block.text"></p>
                <figure v-else-if="block.type === 'image'" class="image-box" :class="{ rounded: block.rounded }">
                  <img :src="block.src" :alt="block.alt || ''" loading="lazy" />
                  <figcaption v-if="block.caption" class="image-caption">{{ block.caption }}</figcaption>
                </figure>
                <div v-else-if="block.type === 'price_range'" class="price-range-box">
                  <div class="price-label">Precio típico en Santiago</div>
                  <div class="price-values">
                    <span>{{ block.currency }}</span>
                    <span class="price-value">{{ block.min.toLocaleString() }}</span>
                    <span class="separator">–</span>
                    <span class="price-value">{{ block.max.toLocaleString() }}</span>
                  </div>
                </div>
                <div v-else-if="block.type === 'table'" class="table-container">
                  <table class="price-table">
                    <thead>
                      <tr>
                        <th v-for="header in block.rows[0]" :key="header">{{ header }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, index) in block.rows.slice(1)" :key="index">
                        <td v-for="cell in row" :key="cell" v-html="tableCellHtml(cell)"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-else-if="block.type === 'faq'" class="faq-section">
                  <h3 class="faq-title">Preguntas frecuentes</h3>
                  <details v-for="item in block.items" :key="item.q" class="faq-item">
                    <summary>
                      <span>{{ item.q }}</span>
                      <span class="faq-icon"></span>
                    </summary>
                    <div class="faq-answer">
                      <p>{{ item.a }}</p>
                    </div>
                  </details>
                </div>
                <div v-else-if="block.type === 'cta'" class="cta-container">
                  <router-link to="/" class="cta-button">{{ block.label }}</router-link>
                </div>
              </section>
            </div>
          </div>

          <div class="json-editor">
            <button class="btn btn-secondary" @click="toggleJsonEditor">
              {{ showJsonEditor ? 'Ocultar JSON' : 'Editar JSON' }}
            </button>
            <div v-if="showJsonEditor" class="json-area-wrapper">
              <textarea
                v-model="jsonSections"
                :rows="jsonRows"
                class="form-control json-area"
              ></textarea>
              <button class="btn btn-primary" @click="applyJsonSections">
                Aplicar JSON
              </button>
              <p v-if="jsonError" class="json-error">{{ jsonError }}</p>
            </div>
          </div>

          <div class="edit-actions">
            <button class="btn btn-secondary" @click="cancelEdit">Cancelar</button>
            <button class="btn btn-primary" @click="savePage">Guardar</button>
            <button
              v-if="editingPage.id"
              class="btn btn-danger"
              @click="deletePage(editingPage)"
            >
              Eliminar
            </button>
          </div>
        </div>
      </div>
      <div v-else class="main-container">
        <p>No tienes permisos para acceder a esta sección.</p>
      </div>
    </div>
  </div>
</template>

<script>
import TopNav from '@/components/TopNav.vue'
import SideNav from '@/components/SideNav.vue'
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'PriceGuideEditor',
  components: {
    TopNav,
    SideNav
  },
  data () {
    return {
      pages: [],
      editingPage: null,
      showPreview: false,
      showJsonEditor: false,
      jsonSections: '',
      jsonError: null,
      loading: false
    }
  },
  computed: {
    ...mapGetters(['admin_datos']),
    jsonRows () {
      return this.jsonSections.split('\n').length + 2
    }
  },
  watch: {
    showJsonEditor (val) {
      if (val) {
        this.jsonSections = JSON.stringify(this.editingPage.sections, null, 2)
        this.jsonError = null
      }
    },
    jsonSections (val) {
      if (!this.showJsonEditor) return
      try {
        const parsed = JSON.parse(val)
        if (Array.isArray(parsed)) {
          this.editingPage.sections = parsed
          this.jsonError = null
        } else {
          this.jsonError = 'El JSON debe ser un arreglo'
        }
      } catch (e) {
        this.jsonError = 'JSON inválido'
      }
    },
    editingPage: {
      handler () {
        this.syncJson()
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    this.fetchPages()
  },
  methods: {
    tableCellHtml (cell) {
      return String(cell == null ? '' : cell)
    },
    initSection (type) {
      switch (type) {
        case 'header_image':
          return { type, src: '', height: 220, rounded: false }
        case 'title':
        case 'subtitle':
        case 'paragraph':
          return { type, text: '' }
        case 'image':
          return { type, src: '', alt: '', caption: '', rounded: false }
        case 'price_range':
          return { type, currency: '', min: 0, max: 0 }
        case 'table':
          return { type, rows: [['', '']] }
        case 'faq':
          return { type, items: [{ q: '', a: '' }] }
        case 'cta':
          return { type, label: '' }
        default:
          return { type }
      }
    },
    onTypeChange (section) {
      const fresh = this.initSection(section.type)
      Object.keys(section).forEach(k => k !== 'type' && delete section[k])
      Object.assign(section, fresh)
      this.syncJson()
    },
    syncJson () {
      if (this.showJsonEditor) {
        this.jsonSections = JSON.stringify(this.editingPage.sections, null, 2)
      }
    },
    async fetchPages () {
      this.loading = true
      try {
        const resp = await axios.get(window.hostname + 'api/superadmin/guias_precio')
        if (resp.data && Array.isArray(resp.data.guias)) {
          this.pages = resp.data.guias.map(g => ({
            id: g.id,
            slug: g.nombre_seo,
            titulo: g.titulo,
            descripcion: g.descripcion,
            imgheader: g.imgheader,
            sections: g.sections || []
          }))
        }
      } catch (e) {
        console.error('Error fetching price guides', e)
      } finally {
        this.loading = false
      }
    },
    createPage () {
      this.editingPage = {
        slug: '',
        titulo: '',
        descripcion: '',
        imgheader: '',
        sections: []
      }
      this.showPreview = false
      this.syncJson()
    },
    editPage (page) {
      this.editingPage = JSON.parse(JSON.stringify(page))
      this.showPreview = false
      this.syncJson()
    },
    cancelEdit () {
      this.editingPage = null
    },
    async savePage () {
      if (!this.editingPage || !this.editingPage.slug) return
      const payload = {
        nombre_seo: this.editingPage.slug,
        titulo: this.editingPage.titulo,
        descripcion: this.editingPage.descripcion,
        imgheader: this.editingPage.imgheader,
        sections: this.editingPage.sections
      }
      this.loading = true
      try {
        if (this.editingPage.id) {
          await axios.put(
            window.hostname + `api/superadmin/guia_precio/${this.editingPage.id}`,
            payload
          )
        } else {
          const resp = await axios.post(
            window.hostname + 'api/superadmin/guia_precio',
            payload
          )
          if (resp.data && resp.data.id) this.editingPage.id = resp.data.id
        }
        await this.fetchPages()
        this.cancelEdit()
      } catch (e) {
        console.error('Error saving guide', e)
      } finally {
        this.loading = false
      }
    },
    async deletePage (page) {
      if (!page.id) return
      if (!confirm('¿Eliminar esta guía?')) return
      this.loading = true
      try {
        await axios.delete(
          window.hostname + `api/superadmin/guia_precio/${page.id}`
        )
        await this.fetchPages()
        if (this.editingPage && this.editingPage.id === page.id) {
          this.cancelEdit()
        }
      } catch (e) {
        console.error('Error deleting guide', e)
      } finally {
        this.loading = false
      }
    },
    addSection () {
      this.editingPage.sections.push({ type: 'paragraph', text: '' })
      this.syncJson()
    },
    removeSection (i) {
      this.editingPage.sections.splice(i, 1)
      this.syncJson()
    },
    addRow (section) {
      const cols = section.rows[0] ? section.rows[0].length : 1
      section.rows.push(Array(cols).fill(''))
    },
    removeRow (section, i) {
      if (section.rows.length > 1) {
        section.rows.splice(i, 1)
      }
    },
    addColumn (section) {
      section.rows.forEach(r => r.push(''))
    },
    removeColumn (section, c) {
      if ((section.rows[0] || []).length <= 1) return
      section.rows.forEach(r => r.splice(c, 1))
    },
    addFaqItem (section) {
      section.items.push({ q: '', a: '' })
    },
    removeFaqItem (section, i) {
      section.items.splice(i, 1)
    },
    moveSectionUp (i) {
      if (i <= 0) return
      const sec = this.editingPage.sections.splice(i, 1)[0]
      this.editingPage.sections.splice(i - 1, 0, sec)
      this.syncJson()
    },
    moveSectionDown (i) {
      if (i >= this.editingPage.sections.length - 1) return
      const sec = this.editingPage.sections.splice(i, 1)[0]
      this.editingPage.sections.splice(i + 1, 0, sec)
      this.syncJson()
    },
    toggleJsonEditor () {
      this.showJsonEditor = !this.showJsonEditor
      this.jsonError = null
      this.syncJson()
    },
    applyJsonSections () {
      try {
        const parsed = JSON.parse(this.jsonSections)
        if (Array.isArray(parsed)) {
          this.editingPage.sections = parsed
          this.jsonError = null
          this.syncJson()
        } else {
          this.jsonError = 'El JSON debe ser un arreglo'
        }
      } catch (e) {
        this.jsonError = 'JSON inválido'
      }
    }
  }
}
</script>

<style scoped>
.price-editor {
  text-align: left;
}
.column-right {
  padding-left: 280px;
  padding-top: 70px;
}
.page-list ul {
  list-style: none;
  padding: 0;
}
.page-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  padding: 6px 0;
}
.page-editor {
  margin-top: 20px;
  padding-left: 20px;
}
.page-title {
  margin-top: 4rem;
}
.section-item {
  border: 1px solid #ddd;
  padding: 10px 15px;
  margin-bottom: 12px;
  border-radius: 4px;
  background: #fff;
}
.section-actions button {
  margin-right: 5px;
}
.editor-block {
  margin-top: 8px;
}
.sections-editor {
  margin-top: 20px;
}
.edit-actions {
  margin-top: 20px;
}
.edit-actions .btn {
  margin-right: 8px;
}
.preview {
  border: 1px dashed #ccc;
  padding: 10px;
  margin-top: 10px;
}
.form-control {
  display: block;
  width: 100%;
  margin-bottom: 5px;
}
.type-select {
  margin-bottom: 5px;
}

.json-area {
  font-family: monospace;
  overflow: hidden;
}
.json-error {
  color: red;
}

.table-editor-container {
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.table-editor {
  min-width: 560px;
}

.table-editor input {
  width: 100%;
}
.table-buttons button {
  margin-right: 5px;
}
.btn-remove-col {
  margin-left: 4px;
}

/* minimal button styling */
.btn {
  padding: 6px 12px;
  border: 1px solid #ccc;
  background: #f8f9fa;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
}
.btn:hover {
  background: #e9ecef;
}
.btn-primary {
  background: #ff8c00;
  border-color: #ff8c00;
  color: #fff;
}
.btn-primary:hover {
  background: #e07a00;
}
.btn-secondary {
  background: #f0f0f0;
  border-color: #ccc;
  color: #333;
}
.btn-secondary:hover {
  background: #e0e0e0;
}
.btn-danger {
  background: #dc3545;
  border-color: #dc3545;
  color: #fff;
}
.btn-danger:hover {
  background: #c82333;
}

/* price page styles for preview */
:root {
  --heading-font: 'Georgia', 'Times New Roman', serif;
  --body-font: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  --text-primary: #212529;
  --text-secondary: #495057;
  --border-color: #e9ecef;
  --background-light: #f8f9fa;
  --border-radius-sm: 4px;
  --border-radius-md: 8px;
}

.price-main {
  background-color: #ffffff;
  padding-top: 2rem;
}

.article-container {
  font-family: var(--body-font);
  background-color: #ffffff;
  max-width: 1400px;
  width: 100%;
  margin: 3rem auto;
  padding: 3rem 2rem;
  text-align: left;
}

.header-image {
  width: 100%;
  background-size: cover;
  background-position: center;
  margin-bottom: 2rem;
}

.header-image.rounded {
  border-radius: 12px;
  overflow: hidden;
}

.content-section + .content-section {
  margin-top: 2rem;
}

.section-paragraph + .content-section:not(.section-paragraph) {
  margin-top: 3rem;
}

.page-title {
  font-family: var(--heading-font);
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
}

.page-subtitle {
  font-size: 1.25rem;
  font-weight: 400;
  color: var(--text-secondary);
  margin-bottom: 2rem;
  line-height: 1.5;
}

p {
  font-size: 1.1rem;
  line-height: 1.7;
  color: var(--text-secondary);
  margin-bottom: 1.5rem;
}

.image-box {
  margin: 1.5rem 0;
  text-align: center;
}

.image-box img {
  max-width: 100%;
  height: auto;
  border-radius: var(--border-radius-sm);
}

.image-box.rounded img {
  border-radius: 12px;
}

.image-caption {
  font-size: 0.9rem;
  color: var(--text-secondary);
  margin-top: 0.5rem;
}

.price-range-box {
  background-color: var(--background-light);
  border-radius: var(--border-radius-md);
  padding: 2rem;
  margin: 2rem 0;
  text-align: center;
}

.price-label {
  color: var(--text-secondary);
  font-weight: 500;
  font-size: 1.1rem;
  margin-bottom: 0.75rem;
}

.price-values {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--text-primary);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}

@media (max-width: 600px) {
  .article-container {
    padding: 2rem 1rem;
  }
  .header-image {
    height: 180px !important;
  }
  .page-title {
    font-size: 2rem;
  }
  .page-subtitle {
    font-size: 1.1rem;
  }
  p {
    font-size: 1rem;
  }
  .price-range-box {
    padding: 1.5rem 1rem;
  }
  .price-values {
    font-size: 1.75rem;
  }
  .price-table th,
  .price-table td {
    font-size: 0.9rem;
    padding: 0.75rem 1rem;
  }
}

.price-value {
  color: #ff8c00;
}

.separator {
  color: var(--text-secondary);
  font-weight: 400;
}

.table-container {
  border-radius: var(--border-radius-md);
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.price-table {
  width: 100%;
  min-width: 640px;
  border-collapse: collapse;
}

.price-table th,
.price-table td {
  padding: 1rem 1.25rem;
  text-align: left;
  border-bottom: 1px solid var(--border-color);
  font-size: 1rem;
}

.price-table th {
  background-color: var(--background-light);
  font-weight: 600;
  color: var(--text-primary);
}

.price-table ::v-deep a {
  color: #0b75c9;
  font-weight: 700;
  text-decoration: none;
}

.price-table ::v-deep a:hover {
  text-decoration: underline;
}

.price-table tbody tr:last-child th,
.price-table tbody tr:last-child td {
  border-bottom: 0;
}

.faq-title {
  font-family: var(--heading-font);
  font-size: 1.75rem;
  margin-bottom: 1.5rem;
  color: var(--text-primary);
}

.faq-item {
  border-top: 1px solid rgba(0,0,0,0.1);
}

.faq-item:last-of-type {
  border-bottom: 1px solid rgba(0,0,0,0.1);
}

.faq-item summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem 0.5rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--text-primary);
  cursor: pointer;
  list-style: none;
}

.faq-answer {
  padding: 0 0.5rem 1.5rem;
  margin-top: -1rem;
}

.faq-answer p {
  font-size: 1rem;
  color: var(--text-secondary);
  margin-bottom: 0;
}

.faq-icon {
  width: 1.25em;
  height: 1.25em;
  transition: transform 0.3s ease-in-out;
  position: relative;
}

.faq-icon::before,
.faq-icon::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 70%;
  height: 2px;
  background-color: var(--text-secondary);
  transform: translate(-50%, -50%);
  transition: transform 0.3s ease-in-out;
}

.faq-icon::after {
  transform: translate(-50%, -50%) rotate(90deg);
}

.faq-item[open] > summary .faq-icon {
  transform: rotate(45deg);
}

.cta-container {
  background-color: var(--background-light);
  text-align: center;
  padding: 2.5rem;
  margin-top: 3rem;
  border-radius: 12px;
}

.cta-button {
  background-color: #ff8c00 !important;
  color: #fff !important;
  padding: 0.875rem 2rem;
  border: none;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.cta-button:hover {
  background-color: #e07a00 !important;
  transform: translateY(-2px);
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.spinner {
  width: 36px;
  height: 36px;
  border: 4px solid #ccc;
  border-top-color: #ff8c00;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
